import moment from "moment";
import formatDate from "./formatDate";

export const resolveDate = async (pendency) => {
    const newPendency = {...pendency};
    if(newPendency.dataHoraInicio){
        const date = moment(newPendency.dataHoraInicio).format('YYYY-MM-DD');
        newPendency.dataHoraInicio = formatDate(moment(`${date} ${newPendency.horaInicio}`, 'YYYY-MM-DD HH:mm'));
        newPendency.dataHoraFim = formatDate(moment(`${date} ${newPendency.horaFim}`, 'YYYY-MM-DD HH:mm'));
    }
    if(!newPendency.horaFim)
        newPendency.dataHoraFim = null;
    delete newPendency.horaInicio;
    delete newPendency.horaFim;
    delete newPendency.horaDivisao;
    return newPendency;
};
export const resolveDateDivider = (pendency) => {
    const newPendency = {...pendency};
    if(newPendency.dataHoraInicio){
        const date = moment(newPendency.dataHoraInicio).format('YYYY-MM-DD');
        newPendency.dataHoraDivisao = formatDate(moment(`${date} ${newPendency.horaDivisao}`, 'YYYY-MM-DD HH:mm'));
    }
    return newPendency.dataHoraDivisao ?? null;
};

export default {
    resolveDate,
    resolveDateDivider,
};
